import Typed from 'typed.js';
export default () => {
  return {
    typewrite(id, strings) {
      new Typed(`#${id}`, {
        strings: strings.split(','),
        typeSpeed: 75,
        backSpeed: 50,
        loop: true,
      });
    },
  }
}
